// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedViewHandleRow_root__KXZQy"};